// Shared jsPDF logo helper — draws the "Fresh Earth" circular seal.
// Matches the /logos → Circular Seal SVG identity so print, PDF and web
// stay visually consistent.
//
// Usage:
//   drawFreshEarthSeal(doc, { x: 42, y: 40, size: 42, tone: "dark" });

const palette = {
  dark:  { forest: [26, 43, 34], terra: [184, 101, 81], moss: [76, 106, 88] },
  light: { forest: [247, 246, 240], terra: [227, 176, 158], moss: [201, 217, 194] },
};

/**
 * Draw the Fresh Earth circular seal into a jsPDF document.
 * All coordinates are in the same units the document was created in (default: pt).
 */
export function drawFreshEarthSeal(doc, opts = {}) {
  const { x = 0, y = 0, size = 42, tone = "dark" } = opts;
  const c = palette[tone] || palette.dark;
  const cx = x + size / 2;
  const cy = y + size / 2;
  const rOuter = size / 2 - 1;
  const rInner = rOuter - Math.max(2, size * 0.08);

  // outer ring
  doc.setDrawColor(c.forest[0], c.forest[1], c.forest[2]);
  doc.setLineWidth(Math.max(0.6, size * 0.02));
  doc.circle(cx, cy, rOuter, "S");

  // inner ring (subtle)
  doc.setDrawColor(c.forest[0], c.forest[1], c.forest[2]);
  doc.setLineWidth(Math.max(0.35, size * 0.008));
  doc.circle(cx, cy, rInner, "S");

  // "Fresh" / "Earth" stacked wordmark (italic serif)
  doc.setTextColor(c.forest[0], c.forest[1], c.forest[2]);
  doc.setFont("times", "italic");
  const wordSize = size * 0.28;
  doc.setFontSize(wordSize);
  const lineGap = wordSize * 0.9;
  doc.text("Fresh", cx, cy - lineGap * 0.05, { align: "center" });
  doc.text("Earth", cx, cy + lineGap * 0.85, { align: "center" });

  // terracotta accent dot below the wordmark (identity signature)
  doc.setFillColor(c.terra[0], c.terra[1], c.terra[2]);
  doc.circle(cx, cy + rInner * 0.62, Math.max(0.8, size * 0.03), "F");
}
